import { _ as _sfc_main } from "./VaRatingItem.vue_vue_type_script_lang-8967fd2f.mjs";
import { resolveComponent, openBlock, createElementBlock, withKeys, withModifiers, renderSlot, normalizeProps, guardReactiveProps, createVNode } from "vue";
import { _ as _export_sfc } from "../../../../../plugin-vue_export-helper-cc2b3d55.mjs";
const VaRatingItem_vue_vue_type_style_index_0_lang = "";
const _hoisted_1 = ["tabindex"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_va_icon = resolveComponent("va-icon");
  return openBlock(), createElementBlock("div", {
    ref: "rootEl",
    role: "button",
    class: "va-rating-item",
    tabindex: _ctx.tabIndexComputed,
    onKeydown: [
      _cache[0] || (_cache[0] = withKeys((...args) => _ctx.onClick && _ctx.onClick(...args), ["enter"])),
      _cache[1] || (_cache[1] = withKeys(withModifiers((...args) => _ctx.onClick && _ctx.onClick(...args), ["prevent"]), ["space"]))
    ],
    onMousemove: _cache[2] || (_cache[2] = (...args) => _ctx.onMouseMove && _ctx.onMouseMove(...args)),
    onMouseleave: _cache[3] || (_cache[3] = (...args) => _ctx.onMouseLeave && _ctx.onMouseLeave(...args)),
    onClick: _cache[4] || (_cache[4] = (...args) => _ctx.onClick && _ctx.onClick(...args))
  }, [
    renderSlot(_ctx.$slots, "default", normalizeProps(guardReactiveProps({ value: _ctx.visibleValue, onClick: _ctx.onClick })), () => [
      createVNode(_component_va_icon, {
        class: "va-rating-item__wrapper",
        tabindex: "-1",
        tag: "button",
        name: _ctx.computedIconName,
        size: _ctx.$props.size,
        color: _ctx.computedColor
      }, null, 8, ["name", "size", "color"])
    ])
  ], 40, _hoisted_1);
}
const _VaRatingItem = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  _VaRatingItem as _
};
//# sourceMappingURL=VaRatingItem-42af4fe6.mjs.map
